export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.8.1',
    name: 'fpar',
    versionDate: '2026-06-24T16:37:43.888Z',
};
export default versions;
